import type { NavigationAdapter } from 'nextstepjs'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Mirrors nextstepjs/adapters/react-router but uses react-router-dom. Vite’s
 * pre-bundle of nextstepjs can resolve a separate react-router copy, so hooks
 * from the package adapter may not see RouterProvider’s context.
 */
export function useAppTourNavigationAdapter(): NavigationAdapter {
  const navigate = useNavigate()
  const location = useLocation()
  const isClient = typeof window !== 'undefined'
  return {
    push: (path: string) => {
      if (isClient) {
        navigate(path)
      }
    },
    getCurrentPath: () => (isClient ? location.pathname : '/'),
  }
}
